import React, { Component } from 'react';
import { disposeOnUnmount, inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { reaction } from 'mobx';
import SubHeader from './SubHeader';
import SelectableDrivers from './SelectableDrivers';
import { Parser as JSON2CSVParser } from 'json2csv';

import './DriversManagerDashboard.css';

@withRouter
@inject('commonStore', 'translationsStore', 'filterStore', 'driversStore')
@observer
class DriversManagerDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount = () => {
    const { commonStore } = this.props;
    this.loadResources();
    disposeOnUnmount(
      this,
      reaction(
        () => commonStore.dealer,
        (dealer, reaction) => {
          if (dealer) {
            const {
              dealer: { masterApiUserUuid: uuid }
            } = commonStore;
            if (!uuid) {
              this.props.history.push('/');
            }
            reaction.dispose();
          }
        },
        { fireImmediately: true }
      )
    );
  };

  componentWillUnmount = () => {
    this.props.filterStore.reset();
  };

  loadResources = () => {
    const { driversStore, commonStore } = this.props;
    commonStore.setLoading(true);
    setTimeout(() => {
      Promise.all([driversStore.load()]).then(() => {
        commonStore.setLoading(false);
      });
    }, 200);
  };

  onExport = () => {
    const { driversStore, translationsStore } = this.props;
    const { filtered } = driversStore;
    if (filtered.length > 0) {
      const fields = [
        {
          label: translationsStore.translate('driversManager.driversTable.headerLabels.name'),
          value: row => `${row.name} ${row.surname}`
        },
        {
          label: translationsStore.translate('driversManager.driversTable.headerLabels.status'),
          value: row => translationsStore.translate(`driversManager.status.${row.managementStatus}`)
        },
        {
          label: translationsStore.translate('driversManager.driversTable.headerLabels.mobile'),
          value: row => (row.mobile ? row.mobile : '-')
        },
        {
          label: translationsStore.translate('driversManager.driversTable.headerLabels.email'),
          value: row => (row.email ? row.email : '-')
        },
        {
          label: translationsStore.translate('driversManager.driversTable.headerLabels.assignedVehicle'),
          value: row => (row.assignedVehicle ? row.assignedVehicle.plate : '-')
        }
      ];

      const exportFilename = 'myfleet.csv';
      try {
        const parser = new JSON2CSVParser({ fields, delimiter: ';', withBOM: true });
        const csv = parser.parse(filtered);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      }
    }
  };

  render() {
    const { driversStore } = this.props;
    return (
      <div className={`DriversManagerDashboard ${this.props.commonStore.loading ? 'loading' : ''}`}>
        <SubHeader onExportClick={this.onExport} />
        {this.props.commonStore.loading === false && <SelectableDrivers drivers={driversStore.drivers} driversFiltered={driversStore.filtered} />}
      </div>
    );
  }
}

export default DriversManagerDashboard;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/DriversManagerDashboard.js